import { Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { TemplateComponent } from '@shared/components/template/template.component';
import { Pages } from '@shared/constants';
import { ScriptPageKeys, StaticPage } from '@shared/models';

@Component({
  selector: 'b2c-cookie-policy',
  imports: [TemplateComponent],
  template: `
    <b2c-template class="container" [template]="pageConfig.template" />
  `,
})
export class CookiePolicyComponent extends BaseComponent implements OnInit {
  public pageConfig: StaticPage = this.loyaltyChallengeConfig.pages
    .cookiePolicy as StaticPage;

  private readonly document: Document = inject(DOCUMENT);

  ngOnInit(): void {
    this.taggingService.loadScriptForPage(ScriptPageKeys.COOKIES_POLICY);
    this.dataService.currentPage.set(Pages.COOKIE_POLICY);
  }

  /**
   * Go back to previous page
   */
  backToPreviousPage(): void {
    this.document.defaultView?.history.back();
  }
}
